import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadsmeetingComponent } from './leadsmeeting.component';

const routes: Routes = [{ path: '', component: LeadsmeetingComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadsmeetingRoutingModule { }
